export type ChangeUserSettingsRequest = {
  settings: UserSettings;
};

export type UserSettings = {
  disableSuccessNotifications?: boolean;
  enableDarkMode?: boolean;
  // ASSIGN_TO
  disableAssignToEmailNotification?: boolean;
  disableAssignToPushNotification?: boolean;
  // UN_ASSIGN_FROM
  disableUnAssignFromEmailNotification?: boolean;
  disableUnAssignFromPushNotification?: boolean;
  // UPDATE_CLIENT_USER
  disableUpdateClientUserEmailNotification?: boolean;
  disableUpdateClientUserPushNotification?: boolean;
  // COMMENT
  disableCommentMentionedEmailNotification?: boolean;
  disableCommentMentionedPushNotification?: boolean;
  // CLIENT_TASK_CREATE
  disableClientTaskCreateEmailNotification?: boolean;
  disableClientTaskCreatePushNotification?: boolean;
  // ASSIGN_TO_TASK
  disableAssignToTaskEmailNotification?: boolean;
  disableAssignToTaskPushNotification?: boolean;
  // UN_ASSIGN_FROM_TASK
  disableUnassignFromTaskEmailNotification?: boolean;
  disableUnassignFromTaskPushNotification?: boolean;
};

export type ChangeUserSettingsResponse = { message: string };

export function useApiUser() {
  const { $client } = useNuxtApp();

  const changeUserSettings = async (
    request: ChangeUserSettingsRequest
  ): Promise<ChangeUserSettingsResponse> => {
    return await $client.user.changeUserSettings.mutate(request);
  };

  return { changeUserSettings };
}

